<script setup>
import {computed, ref, onMounted, onUnmounted, getCurrentInstance} from 'vue';
import {useStore} from 'vuex';
import {useI18n} from 'vue-i18n';
import $http from '@/axios.config';
import {log} from "@/utils/clientLogger.js";

const store = useStore();
const {t} = useI18n();

const isMenuOpen = ref(false);
const dropdownRoot = ref(null); // Ref для кореневого елемента

const allStatuses = computed(() => store.getters.allStatuses);
const currentUser = computed(() => store.getters.userData);
const userRole = computed(() => store.getters.userRole);
const instance = getCurrentInstance();

const availableStatuses = computed(() => {
  if (!userRole.value) return [];
  if (userRole.value === 'admin') return allStatuses.value;
  return allStatuses.value.filter(status => status.role && status.role.name === userRole.value);
});

const currentStatusObject = computed(() => {
  return allStatuses.value.find(s => s._id === currentUser.value.currentStatus);
});

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}

const handleClickOutside = (event) => {
  if (dropdownRoot.value && !dropdownRoot.value.contains(event.target)) {
    isMenuOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

async function setStatus(statusId) {
  isMenuOpen.value = false; // Закриваємо меню після вибору
  try {
    const response = await $http.put('/api/users/me/status', {statusId});
    const socket = instance.appContext.config.globalProperties.$socket;
    if (socket) {
      socket.emit('user-status-updated', response.data);
    } else {
      log.warn('View:UserStatusSelector:setStatus', {
        'message': 'Socket.IO not found, event not sent!'
      });
    }

    await store.dispatch('fetchUserData');

  } catch (error) {
    log.error("View:UserStatusSelector:setStatus", {
      'error': error,
      'message': 'Error updating status'
    });
    if (error.response) {
      log.error("View:UserStatusSelector:setStatus", {
        'error': error.response.data,
        'message': 'Server response data (error)'
      });
      log.error("View:UserStatusSelector:setStatus", {
        'error': error.response.status,
        'message': 'Server response status'
      });
    }
  }
}
</script>

<template>
  <div class="dropdown" ref="dropdownRoot">
    <button class="btn btn-secondary dropdown-toggle d-flex align-items-center px-5" type="button" @click="toggleMenu">
      <template v-if="currentStatusObject">
        <span class="d-inline-block me-2" :style="{ backgroundColor: currentStatusObject.color, width: '12px', height: '12px', borderRadius: '50%' }"></span>
        {{ currentStatusObject.name }}
      </template>
      <template v-else>
        {{ t('labels.setStatus') }}
      </template>
    </button>
    <ul class="dropdown-menu" :class="{ 'show': isMenuOpen }">
      <li v-for="status in availableStatuses" :key="status._id">
        <a class="dropdown-item" href="#" @click.prevent="setStatus(status._id)">
          <span class="d-inline-block me-2" :style="{ backgroundColor: status.color, width: '12px', height: '12px', borderRadius: '50%' }"></span>
          {{ status.name }}
        </a>
      </li>
      <template v-if="availableStatuses.length > 0">
        <li>
          <hr class="dropdown-divider">
        </li>
        <li>
          <a class="dropdown-item text-muted" href="#" @click.prevent="setStatus(null)">
            {{ t('buttons.clearStatus') }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.dropdown-menu.show {
  display: block;
}
</style>